import { useQuery } from "@tanstack/react-query"

import { getResumenPaciente } from "../services/pacienteview.service";

export const useResumenPaciente = (id) => {

    const resumenPacienteQuery = useQuery({
        queryKey: ['resumenPaciente', id],
        queryFn: () => getResumenPaciente(id),
        staleTime: 0, // null
    });

    return {
        resumenPacienteQuery
    }
}